/**
 * Email utility functions for member center
 */

// Temp email domain constants
const TEMP_LINE_DOMAIN = '@temp.line';
const LIFF_TEMP_DOMAIN = '@liff.temp';

/**
 * Check if an email is a temporary LINE login email
 * Temporary emails have formats: {lineUserId}@temp.line or {lineUserId}@liff.temp
 *
 * @param email - The email address to check
 * @returns true if the email is a temporary LINE email
 */
export function isTempEmail(email: string): boolean {
  if (!email) return false;
  const lowerEmail = email.toLowerCase();
  return lowerEmail.endsWith(TEMP_LINE_DOMAIN) || lowerEmail.endsWith(LIFF_TEMP_DOMAIN);
}

/**
 * Format email for display
 * Returns '<未綁定>' for temporary emails, otherwise returns the email as-is
 *
 * @param email - The email address to format
 * @returns Formatted email display text
 */
export function formatEmailDisplay(email: string | null | undefined): string {
  if (!email) return '<未綁定>';
  if (isTempEmail(email)) {
    return '<未綁定>';
  }
  return email;
}

/**
 * Extract line user ID from temporary email
 *
 * @param email - The temporary email address
 * @returns The LINE user ID or null if not a temp email or extraction fails
 */
export function extractLineUserIdFromTempEmail(email: string): string | null {
  if (!isTempEmail(email)) return null;

  const lowerEmail = email.toLowerCase();
  let userId: string;

  if (lowerEmail.endsWith(TEMP_LINE_DOMAIN)) {
    userId = email.slice(0, -TEMP_LINE_DOMAIN.length);
  } else if (lowerEmail.endsWith(LIFF_TEMP_DOMAIN)) {
    userId = email.slice(0, -LIFF_TEMP_DOMAIN.length);
  } else {
    return null;
  }

  // Return null if userId is empty (edge case: email is just the domain)
  if (!userId) return null;
  return userId;
}
